//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Norton',
  data () {
    return {
      form: {
        physical: '',
        mental: '',
        activity: '',
        mobility: '',
        incontinence: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '4', name: '尚可', desc: ''},
        {value: '3', name: '一般', desc: ''},
        {value: '2', name: '较差', desc: ''},
        {value: '1', name: '极差', desc: ''}
      ],
      dataList2: [
        {value: '4', name: '清醒', desc: ''},
        {value: '3', name: '淡漠', desc: ''},
        {value: '2', name: '混乱', desc: ''},
        {value: '1', name: '昏迷', desc: ''}
      ],
      dataList3: [
        {value: '4', name: '自主行走', desc: ''},
        {value: '3', name: '辅助行走', desc: ''},
        {value: '2', name: '轮椅', desc: ''},
        {value: '1', name: '卧床', desc: ''}
      ],
      dataList4: [
        {value: '4', name: '正常', desc: ''},
        {value: '3', name: '轻度受限', desc: ''},
        {value: '2', name: '严重受限', desc: ''},
        {value: '1', name: '瘫痪', desc: ''}
      ],
      dataList5: [
        {value: '4', name: '无', desc: ''},
        {value: '3', name: '偶尔', desc: ''},
        {value: '2', name: '经常（小便）', desc: ''},
        {value: '1', name: '经常（二便）', desc: ''}
      ]
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
        result += Number(form[key])
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Nurse/Norton.vue